(function() {
  const formContainer = document.getElementById('form-container');

  if (!formContainer) {
    return;
  }

  formContainer.classList.add('loading');

  const checkInterval = setInterval(function() {
    const iframe = formContainer.querySelector('iframe');

    if (iframe) {
      clearInterval(checkInterval);

      setTimeout(function() {
        formContainer.classList.remove('loading');
      }, 2000);

      iframe.addEventListener('load', function() {
        formContainer.classList.remove('loading');
      });
    }
  }, 100);

  setTimeout(function() {
    clearInterval(checkInterval);
    formContainer.classList.remove('loading');
  }, 5000);
})();